<template>
  <b-card>
    <div v-if="isUpdate">
      <b-form-group
          label="Meta keywords"
          label-cols-lg="3"
          label-cols-sm="12"
          label-for="meta_keywords"
      >
        <ValidationProvider
            v-slot="{ errors }"
            :rules="{
                  required: false
                }"
            name="meta_keywords"
        >
          <b-form-tags
              id="meta_keywords"
              v-model="form.metaKeyword"
              :state="errors[0] ? false : null"
          ></b-form-tags>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
          label="Meta description"
          label-cols-lg="3"
          label-cols-sm="12"
          label-for="meta_description"
      >
        <ValidationProvider
            v-slot="{ errors }"
            :rules="{
                  required: false,
                }"
            name="meta_description"
        >
          <b-form-input
              id="meta_description"
              v-model="form.metaDescription"
              :state="errors[0] ? false : null"
          ></b-form-input>
        </ValidationProvider>
      </b-form-group>
      <hr />
    </div>

    <b-form-group
        label="โลโก้"
        label-cols-lg="3"
        label-cols-sm="12"
        label-for="logo"
    >
      <ValidationProvider
          v-slot="{ errors }"
          :rules="isUpdate ? null : 'required'"
          name="logo"
      >
        <b-form-file
            id="logo"
            v-model="files.logo"
            :state="errors[0] ? false : null"
            accept="image/*"
            readonly
        >
        </b-form-file>
      </ValidationProvider>
      <b-form-text v-if="form.logo">
        <a v-if="typeof form.logo === 'string'" :href="form.logo" target="_blank">ดูรูป</a>
        <template v-else>
          <a
              href="#"
              target="_blank"
              @click.prevent="getDataUrlFromImage(form.logo)"
          >
            ดูรูป
          </a>
          <b-link
              class="text-danger"
              @click="form.logo = null"
          >
            {{ $t('buttons.remove') }}
          </b-link>
        </template>
      </b-form-text>
    </b-form-group>

    <b-form-group
        label="ไอคอนเว็บ (16x16)"
        label-cols-lg="3"
        label-cols-sm="12"
        label-for="favicon"
    >
      <ValidationProvider
          v-slot="{ errors }"
          :rules="isUpdate ? null : 'required'"
          name="favicon"
      >
        <b-form-file
            id="favicon"
            v-model="files.favicon"
            :state="errors[0] ? false : null"
            accept="image/*"
            readonly
        >
        </b-form-file>
      </ValidationProvider>
      <b-form-text v-if="form.favicon">
        <a v-if="typeof form.favicon === 'string'" :href="form.favicon" target="_blank">ดูรูป</a>
        <template v-else>
          <a
              href="#"
              target="_blank"
              @click.prevent="getDataUrlFromImage(form.favicon)"
          >
            ดูรูป
          </a>
          <b-link
              class="text-danger"
              @click="form.favicon = null"
          >
            {{ $t('buttons.remove') }}
          </b-link>
        </template>
      </b-form-text>
    </b-form-group>

    <b-form-group
        label="พื้นหลัง"
        label-cols-lg="3"
        label-cols-sm="12"
        label-for="bg"
    >
      <b-form-radio-group
          v-model="form.backgroundType"
          :options="bgTypeOption"
          button-variant="outline-primary"
          buttons
      >
      </b-form-radio-group>
      <div v-show="form.backgroundType === 'color'" id="backgroundColor" :acp-color="form.backgroundColor || '#DEDEDE'"
           acp-show-alpha
           acp-show-hex="yes"
           acp-show-hsl="no"
           acp-show-rgb="yes"
           class="mt-3">
      </div>
      <div v-show="form.backgroundType === 'image'" class="mt-2">
        <ValidationProvider
            v-slot="{ errors }"
            :rules="isUpdate ? null : 'required'"
            name="bgImage"
        >
          <b-form-file
              id="bgImage"
              v-model="form.backgroundImage"
              :state="errors[0] ? false : null"
              accept="image/*"
              readonly
          >
          </b-form-file>
        </ValidationProvider>
        <b-form-text v-if="form.backgroundImage">
          <a v-if="typeof form.backgroundImage === 'string'" :href="form.backgroundImage" target="_blank">ดูรูป</a>
          <template v-else>
            <a
                href="#"
                target="_blank"
                @click.prevent="getDataUrlFromImage(form.backgroundImage)"
            >
              ดูรูป
            </a>
            <b-link
                class="text-danger"
                @click="form.backgroundImage = null"
            >
              {{ $t('buttons.remove') }}
            </b-link>
          </template>
        </b-form-text>
      </div>
    </b-form-group>
    <hr />
    <div class="row">
      <div class="col-md-6">
        สีหลัก
        <div id="primaryColor" :acp-color="form.primaryColor || '#c80000'"
             acp-show-alpha
             acp-show-hex="yes"
             acp-show-hsl="no"
             acp-show-rgb="yes"
             class="mt-3">
        </div>
      </div>
      <div class="col-md-6">
        สีรอง
        <div id="secondaryColor" :acp-color="form.secondaryColor || '#a2a2a2'"
             acp-show-alpha
             acp-show-hex="yes"
             acp-show-hsl="no"
             acp-show-rgb="yes"
             class="mt-3">
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import * as AColorPicker from 'a-color-picker'

export default {
  page: {
    title: 'ตั้งค่าเอเย่นต์ | ตั้งค่าเว็บไซต์',
  },
  props: {
    agentData: {
      type: Object,
      default: () => ({
        logo: null,
        favicon: null,
        metaKeyword: [],
        metaDescription: '',
        siteThemeConfig: {}
      }),
    },
    isUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: {
        favicon: null,
        logo: null,
      },
      form: {},
      bgTypeOption: [
        { text: 'รูป', value: 'image' },
        { text: 'สี', value: 'color' },
      ]
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('update', val)
      },
      deep: true
    },
    files: {
      deep: true,
      handler(val) {
        this.form.logo = val.logo || this.agentData.logo
        this.form.favicon = val.favicon || this.agentData.metaIconSrc
      }
    }
  },
  created() {
    this.form = {
      logo: this.agentData?.siteThemeConfig?.logoUrl || this.agentData.logo,
      favicon: this.agentData.metaIconSrc,
      metaKeyword: this.agentData.metaKeyword,
      metaDescription: this.agentData.metaDescription,
      backgroundType: this.agentData?.siteThemeConfig?.backgroundType || 'image',
      primaryColor: this.agentData?.siteThemeConfig?.primaryColor || '#c80000',
      secondaryColor: this.agentData?.siteThemeConfig?.secondaryColor || '#a2a2a2',
      tertiaryColor: '#ffffff',
      backgroundImage: null,
      backgroundColor: null
    }
    if (this.form.backgroundType === 'image') {
      this.form.backgroundImage = this.agentData?.siteThemeConfig?.background || null
    } else {
      this.form.backgroundColor = this.agentData?.siteThemeConfig?.background || null
    }
  },
  mounted() {
    AColorPicker
        .from('div#backgroundColor')
        .on('change', (picker, color) => {
          this.form.backgroundColor = color
        })
    AColorPicker
        .from('div#primaryColor')
        .on('change', (picker, color) => {
          this.form.primaryColor = color
        })
    AColorPicker
        .from('div#secondaryColor')
        .on('change', (picker, color) => {
          this.form.secondaryColor = color
        })
  },
  methods: {
    async getDataUrlFromImage(image) {
      if (image) {
        if(typeof image === 'string') {
          window.open(image)
        } else {
          const reader = new FileReader();
          reader.onload = () => {
            const tmpImage = new Image()
            tmpImage.src = reader.result
            window.open('').document.write(tmpImage.outerHTML);
          };
          reader.readAsDataURL(image);
        }
      }
    },
  }
}
</script>

<style></style>
